"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableSharedBuswayIcon = PrintableSharedBuswayIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableSharedBuswayIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0.5 0 32 32"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M16 0c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16zM5.232 6.208h5.836c0.528 0 0.958 0.434 0.958 0.958 0 0.53-0.432 0.96-0.958 0.96h-7.308c0.44-0.678 0.93-1.322 1.472-1.918zM2.942 9.566h10.526c0.53 0 0.75 0.432 0.75 0.958v4.796c0 0.528-0.22 0.958-0.75 0.958h-12.022c0-0.090-0.006-0.184-0.006-0.278 0-2.308 0.54-4.494 1.502-6.434zM14.216 19.638v0.96c0 0.53-0.43 0.958-0.96 0.958h-2.396c-0.532 0-0.96-0.428-0.96-0.958v-0.96c0-0.528 0.43-0.958 0.96-0.958h2.396c0.532 0 0.96 0.432 0.96 0.958zM16 30.558c-4.45 0-8.438-2.008-11.112-5.164h5.49v1.92c0 2.398 3.838 2.398 3.838 0v-1.92h1.918v-15.828c0 0 0.236-4.796-5.118-4.796h-4.274c2.518-2.080 5.744-3.332 9.258-3.332 8.030 0 14.56 6.534 14.56 14.562s-6.53 14.558-14.56 14.558z",
    fill: color
  }));
}